import { CapacitorConfig } from '@capacitor/cli';

export type AppConfig = CapacitorConfig & {
  plugins: {
    SocialLogin: {
      google: {
        webClientId: string;
        iOSClientId: string;
        mode: 'online' | 'offline';
      };
      apple: {
        clientId: string;
      };
    };
  };
};

const config: AppConfig = {
  appId: 'com.workingdevshero.olympia',
  appName: 'Olympia Fitness',
  webDir: 'www/browser',
  server: {
    androidScheme: 'https',
  },
  plugins: {
    SocialLogin: {
      google: {
        webClientId:
          '527352627850-sulftvcvibgvqlm45b6prm8ouipmntjd.apps.googleusercontent.com',
        iOSClientId:
          '527352627850-dlfbr1jaon5u9tt84v4s1p78a3sqtg7h.apps.googleusercontent.com',
        mode: 'online',
      },
      apple: {
        clientId: 'com.workingdevshero.olympia',
      },
    },
    MediaCapture: {
      cordovaPluginName: 'cordova-plugin-media-capture',
    },
  },
};

export default config;
